import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withUnvalidatedControlErrors, withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import {
  entityIs,
  propertyIs,
  andComp,
} from '@bingads-webui-campaign-react/form-error';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  TextTitle,
  ValidatedPanel,
  getPanelErrorProps
} from '@bingads-webui-campaign/wizard-jumbo-card';

import { ERROR_ENTITY, campaignLanguageStrings } from '../../constants';
import { LanguageImg } from '../../media';
import { ValidatedSingleLanguageTarget, SingleLanguageTargetValidator } from '../validated-language-target';

const entityIsAdgroup = entityIs(ERROR_ENTITY.AdGroup);
const adgroupLanguageProp = andComp(entityIsAdgroup, propertyIs('Language'));

const ServerValidatedLanguageTarget = withControlErrorHandling(withUnvalidatedControlErrors(ValidatedSingleLanguageTarget, { filter: adgroupLanguageProp }));

export const SingleLanguageTargetPanel = (props) => {
  const serverContext = useContext(ServerContext);
  const i18n = useContext(I18nContext);

  const {
    CurrentLocale: locale,
    DynamicPermissions,
    Permissions,
  } = serverContext;

  const permissions = useMemo(() => ({ dynamic: { ...DynamicPermissions }, ...Permissions }), [DynamicPermissions, Permissions]);

  const {
    expand,
    data = {},
    ...rest
  } = props;

  return (
    <ValidatedPanel
      key="language"
      title={<TextTitle
        titleKey={_TL_('Language')}
        icon={LanguageImg}
        topicKey="pop_BA_Apps_Language"
        details={i18n.getString(campaignLanguageStrings[data.Language || 'None'] || _TL_(`${data.Language}`))}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'language',
      }}
      {...rest}
    >
      <ServerValidatedLanguageTarget
        locale={locale}
        permissions={permissions}
        validationProps={{
          field: 'Language',
          data,
          validator: permissions.IsDomesticSimplifiedChineseEnabled ? undefined : SingleLanguageTargetValidator,
        }}
        showSelectedLanguages={false}
        multiSelect={false}
        supportAllOption={false}
        additionalOptions={permissions.IsDomesticSimplifiedChineseEnabled ? [] : ['None']}
      />
    </ValidatedPanel>
  );
};

SingleLanguageTargetPanel.propTypes = {
  expand: PropTypes.func.isRequired,
  data: PropTypes.shape({}),
};

SingleLanguageTargetPanel.defaultProps = {
  data: {},
};
